import { useCallback, useMemo, useState } from 'react'
import {
  LOGIN_FORM,
  MFA_SELECTOR as MFA_SELECTOR_STEP,
  MFA as MFA_STEP,
} from '../../constants/steps'
import LoginPage from '../../pages/Login'
import MFA from '../../pages/MFA'
import MFASelector from '../../pages/MFASelector'
import { LoginContext } from '../../contexts/Login'
import '../../../assets/css/index.css'

const currentTimeSeconds = () => new Date().getTime() / 1000

const Root = (props) => {
  const [step, setStep] = useState(LOGIN_FORM)
  const [loginTimestamp, setLoginTimestamp] = useState(() =>
    currentTimeSeconds(),
  )
  const [selectedMFA, setSelectedMFA] = useState(null)
  const [mfas, setMfas] = useState([])
  const [credentials, setCredentials] = useState({ username: '', password: '' })

  const changeStep = useCallback((newStep) => setStep(newStep), [])

  const selectMFA = useCallback(
    (mfaType) =>
      setSelectedMFA(
        (current) => mfas.find((mfa) => mfa.type === mfaType) || current,
      ),
    [mfas],
  )

  const setMFAs = useCallback((newMfas) => {
    setMfas(newMfas)
    setLoginTimestamp(currentTimeSeconds())
  }, [])

  const updateCredentials = useCallback((field, value) => {
    setCredentials((prev) => ({ ...prev, [field]: value }))
  }, [])

  const getSelectedMFA = useCallback(
    () => selectedMFA || mfas[0],
    [selectedMFA, mfas],
  )

  const contextValue = useMemo(
    () => ({
      step,
      loginTimestamp,
      selectedMFA,
      mfas,
      credentials,
      updateCredentials,
      changeStep,
      setMFAs,
      selectMFA,
    }),
    [
      step,
      loginTimestamp,
      selectedMFA,
      mfas,
      credentials,
      updateCredentials,
      changeStep,
      setMFAs,
      selectMFA,
    ],
  )

  const renderStep = (currentStep) => {
    return {
      [LOGIN_FORM]: <LoginPage {...props} />,
      [MFA_STEP]: (
        <MFA
          mfa={getSelectedMFA()}
          loginTimestamp={loginTimestamp}
          changeStep={changeStep}
          {...props}
        />
      ),
      [MFA_SELECTOR_STEP]: (
        <MFASelector
          mfas={mfas}
          changeStep={changeStep}
          selectMFA={selectMFA}
          {...props}
        />
      ),
    }[currentStep]
  }

  return <LoginContext value={contextValue}>{renderStep(step)}</LoginContext>
}

export default Root
